import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=ec6f93f0&scoped=true&"
import script from "./PatientDetail.vue?vue&type=script&lang=js&"
export * from "./PatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=ec6f93f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6f93f0",
  null
  
)

export default component.exports